import React from "react";
import * as MUI from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import { useTranslation } from "react-i18next";
import WarehouseServiceDetailsContent from "./WarehouseServiceDetailsContent";

// Mirrors WarehouseItemDetailsDialog.jsx's header exactly: Delete/Edit on
// the left, X-close only on the right - no History (services have no
// auditing), no label-queue/shopping-list toggles, no ViewFullPage (no
// full-page route exists for services).
export default function WarehouseServiceDetailsDialog({
  service,
  currency,
  canEdit,
  canDelete,
  onClose,
  onEdit,
  onDelete,
}) {
  const { t } = useTranslation();
  const theme = MUI.useTheme();
  const fullScreen = MUI.useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MUI.Dialog
      open={Boolean(service)}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}
    >
      <MUI.DialogTitle sx={{ p: { xs: 2.5, sm: 3.5 }, pt: { xs: 1, sm: 1.25 } }}>
        <MUI.Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <MUI.Stack direction="row" spacing={0.5}>
            {canDelete && (
              <MUI.Tooltip title={t("Delete")}>
                <MUI.IconButton
                  onClick={() => onDelete(service)}
                  size="small"
                  color="error"
                >
                  <DeleteIcon fontSize="small" />
                </MUI.IconButton>
              </MUI.Tooltip>
            )}
            {canEdit && (
              <MUI.Tooltip title={t("Edit")}>
                <MUI.IconButton onClick={() => onEdit(service)} size="small">
                  <EditIcon fontSize="small" />
                </MUI.IconButton>
              </MUI.Tooltip>
            )}
          </MUI.Stack>

          <MUI.IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </MUI.IconButton>
        </MUI.Stack>

        <MUI.Stack direction="row" spacing={2} alignItems="center">
          <MUI.Avatar
            variant="rounded"
            sx={{
              bgcolor: "primary.main",
              width: 52,
              height: 52,
              borderRadius: 2.5,
            }}
          >
            <MedicalServicesOutlinedIcon />
          </MUI.Avatar>
          <MUI.Box sx={{ minWidth: 0 }}>
            <MUI.Typography
              variant="h6"
              sx={{ fontWeight: 700, lineHeight: 1.25 }}
              noWrap
            >
              {service?.title}
            </MUI.Typography>
            <MUI.Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ mt: 0.5 }}
            >
              <MUI.Chip
                label={`${t("ID")}: ${service?.id}`}
                size="small"
                color="primary"
              />
            </MUI.Stack>
          </MUI.Box>
        </MUI.Stack>
      </MUI.DialogTitle>

      <MUI.DialogContent
        dividers
        sx={{
          p: { xs: 2.5, sm: 3.5 },
          bgcolor: (theme) =>
            theme.palette.mode === "light"
              ? "grey.50"
              : "rgba(255,255,255,0.02)",
        }}
      >
        <WarehouseServiceDetailsContent service={service} currency={currency} />
      </MUI.DialogContent>
    </MUI.Dialog>
  );
}
